import React from "react";
import { Card } from "../ui/card";

export const KpiCards = ({ metrics }) => (
    <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-6">
        {metrics.map((m, i) => (
            <Card key={i} className="p-4 min-w-0">
                <div className="text-3xl font-bold" style={{ wordBreak: "normal", overflowWrap: "anywhere" }}>
                    {m.value}
                </div>
                <div className="text-sm text-muted-foreground" style={{ wordBreak: "normal", overflowWrap: "anywhere" }}>
                    {m.label}
                </div>
            </Card>
        ))}
    </div>
);

export default KpiCards;
